import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const CALL_GENERATOR_LOG = "CALL_GENERATOR_LOG";
export const CALL_GENERATOR_LOG_ERROR = "CALL_GENERATOR_LOG_ERROR";
export const CALL_GENERATOR_LOG_SUCCESS = "CALL_GENERATOR_LOG_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  data: [],
  error: false,
  loading: false,
  lastItem: {},
};

export const callGeneratorLogReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case CALL_GENERATOR_LOG:
      return {
        ...state,
        loading: true,
      };
    case CALL_GENERATOR_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        lastItem: action.payload.lastItem,
      };
    case CALL_GENERATOR_LOG_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const callGeneratorLog = (where) => ({
  type: CALL_GENERATOR_LOG,
  data: {
    where,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      callGeneratorLog,
    },
    dispatch
  );
};

/**
 * Apis
 */
const callGeneratorLogApi = (where) => {
  return apiCaller.getLogs(`/mini-crm/call-generator-log`, { ...where });
};

/**
 * sagas
 */

export const callGeneratorLogFlow = function* () {
  while (true) {
    const action = yield take(CALL_GENERATOR_LOG);
    try {
      const res = yield call(callGeneratorLogApi, action.data.where);
      const data = res.data.sort(function (a, b) {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      });
      const reportGroups = {
        campaign: {
          fields: ["campaign.name"],
        },
      };
      data.forEach((item) => {
        item.groups = {};
        for (const groupName in reportGroups) {
          // eslint-disable-next-line no-prototype-builtins
          if (reportGroups.hasOwnProperty(groupName)) {
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });
      const lastItem = data.slice(-1)[0];
      yield put({
        type: CALL_GENERATOR_LOG_SUCCESS,
        payload: { ...data, lastItem: lastItem },
      });
    } catch (error) {
      yield put({ type: CALL_GENERATOR_LOG_ERROR, error });
    }
  }
};
